<!--DESKTOP VIEW-->
<div class="nav-dividends-main content-web-section">
  <div class="row">
    <div class="col-lg-3"></div> 
    <div class="col-lg-6 main-tab-resp row" role="tablist" aria-label="Main Navigation Tabs">
      <!-- <div class="tab-set cursor-pointer text-center radius-left" [ngClass]="{'active-tab':activeTab==='nav'}"
        (click)="setActive('nav')"> -->
        <div
  #mainTab
  id="tab-nav"
  class="tab-set cursor-pointer text-center radius-left"
  role="tab"
  [attr.aria-selected]="activeTab === 'nav'"
  [attr.aria-controls]="'panel-nav'"
  [attr.tabindex]="activeTab === 'nav' ? '0' : '-1'"
  [ngClass]="{'active-tab':activeTab==='nav'}"
  (click)="setActive('nav')"
  (keydown)="onMainTabKeydown($event,0)">

  <span class="left-buttons text-center">
    <span class="tab-btn-text">NAV</span>
  </span>

</div>
      <!-- <div class="tab-set  cursor-pointer text-center radius-right" [ngClass]="{'active-tab':activeTab==='dividends'}"
        (click)="setActive('dividends')"> -->
     <div
  #mainTab
  id="tab-idcw"
  class="tab-set cursor-pointer radius-right"
  role="tab"
  [attr.aria-selected]="activeTab === 'dividends'"
  [attr.aria-controls]="'panel-idcw'"
  [attr.tabindex]="activeTab === 'dividends' ? '0' : '-1'"
  [ngClass]="{'active-tab':activeTab==='dividends'}"
  (click)="setActive('dividends')"
  (keydown)="onMainTabKeydown($event,1)">

  <span class="left-buttons text-center">
    <span class="tab-btn-text">IDCW</span>
  </span>

</div>
    </div>
     <div class="col-lg-3"></div> 
  </div>
  <div class="data-section-nav" [attr.role]="'tabpanel'" [attr.id]="activeTab === 'nav' ? 'panel-nav' : 'panel-idcw'" [attr.aria-labelledby]="activeTab === 'nav' ? 'tab-nav' : 'tab-idcw'">
    <div class="row nav-tabs-section align-center">
      <div class="col-lg-12" role="tablist" aria-label="Current and Historic Tabs">
        <!-- <span class="sub-nav cursor-pointer margin-right-30" [ngClass]="{'active-tab':activeTabSub==='current'}"
          (click)="setActiveSub('current')"> -->
        <span
        #subTab
        id="tab-current"
        class="sub-nav cursor-pointer margin-right-30"
        role="tab"
        aria-controls="panel-current"
        [attr.aria-selected]="activeTabSub==='current'"
        [attr.tabindex]="activeTabSub==='current' ? '0' : '-1'"
        [ngClass]="{'active-tab':activeTabSub==='current'}"
        (click)="setActiveSub('current')"
        (keydown)="onSubTabKeydown($event,0)">
          <span *ngIf="activeTab==='nav'">Current NAV</span>
          <span *ngIf="activeTab==='dividends'">Latest IDCW </span>
        </span> 
        <!-- <span class="sub-nav cursor-pointer sub-nav-responsive" [ngClass]="{'active-tab':activeTabSub==='historic'}"
          (click)="setActiveSub('historic')"> -->
       <span
      #subTab
      id="tab-historic"
      class="sub-nav cursor-pointer sub-nav-responsive"
      role="tab"
      aria-controls="panel-historic"
      [attr.aria-selected]="activeTabSub==='historic'"
      [attr.tabindex]="activeTabSub==='historic' ? '0' : '-1'"
      [ngClass]="{'active-tab':activeTabSub==='historic'}"
      (click)="setActiveSub('historic')"
      (keydown)="onSubTabKeydown($event,1)">
          <span *ngIf="activeTab==='nav'">Historic NAV</span>
          <span *ngIf="activeTab==='dividends'">Historic IDCW</span>
        </span>
     </div> 
    </div>
    <div id="panel-historic" role="tabpanel" aria-labelledby="tab-historic" class="col-lg-12 row filters ml-1" *ngIf="activeTabSub==='historic'">
       <!-- Select Scheme -->
      <div class="col-lg-3">
          <div class="form-group padding-right-10">
            <mat-form-field style="padding-left:10px;">
              <mat-label>Select Scheme</mat-label>
              <input type="text" [formControl]="schemeControl" placeholder="Select Scheme" matInput [matAutocomplete]="schemeAutocomplete">
              <button mat-icon-button matSuffix (click)="showAllScheme()" tabindex="-1">
                 <mat-icon>arrow_drop_down</mat-icon>
               </button>
              <!-- <mat-autocomplete #schemeAutocomplete="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onSchemeChange($event)"> -->
                <mat-autocomplete
                #schemeAutocomplete="matAutocomplete"
                [displayWith]="displayFn"
                autoActiveFirstOption
                (optionSelected)="onSchemeChange($event)">
               <mat-option *ngFor="let item of filteredSchemeList | async" [value]="item">
                 {{ item.scheme }}
               </mat-option>
             </mat-autocomplete>
             </mat-form-field>
          </div>
      </div>
        <!-- Select Plan -->
      <div class="col-lg-3">
        <div class="form-group stretch">
          <mat-form-field>
            <mat-label>Select Plan</mat-label>
              <!-- <mat-select
              disableOptionCentering
              placeholder="Select Plan"
              [(ngModel)]="userData.plan"
              name="schemePlan"
              #schemePlan="ngModel"> -->
              <mat-select
              disableOptionCentering
              placeholder="Select Plan"
              [(ngModel)]="userData.plan"
              name="schemePlan"
              #schemePlan="ngModel"
              (openedChange)="onPlanOpened($event)">
              <mat-option *ngFor="let item of planList" [value]="item.plan">
                {{item.plan}}
              </mat-option>
          </mat-select>
          </mat-form-field>
        </div>
      </div>
       <!-- Select From Date -->
      <div class="col-lg-3">
        <div class="form-group">
        <mat-form-field>
          <mat-label>From</mat-label>
          <input
              type="text"
              matInput
              [matDatepicker]="picker1"
              [(ngModel)]="userData.fromDate"
              name="fromDate"
              [max]="today"
          >
          <mat-datepicker-toggle
              matSuffix
              [for]="picker1"
              aria-label="Open calendar for: From"
          ></mat-datepicker-toggle>
          <mat-datepicker
              #picker1
              color="primary"
          ></mat-datepicker>
      </mat-form-field>
      </div>

      </div>
       <!-- Select From Date -->
      <div class="col-lg-3">
        <div class="form-group">
          <mat-form-field>
            <mat-label>To</mat-label>
              <input
                  type="text"
                  matInput
                  [matDatepicker]="picker2"
                  [(ngModel)]="userData.toDate"
                  name="toDate"
                  [max]="today"
                  [min]="userData.fromDate"
              >
              <mat-datepicker-toggle
                  matSuffix
                  [for]="picker2"
                  aria-label="Open calendar for: To"
              ></mat-datepicker-toggle>
              <mat-datepicker
                  #picker2
                  color="primary"
              ></mat-datepicker>
          </mat-form-field>
      </div>

      </div>
    </div>

    <!--NAV TAB => CURRENTNAV FORM FILTER-->
    <div id="panel-current" role="tabpanel" aria-labelledby="tab-current" class="row width-stretch-65 margin-auto" *ngIf="activeTabSub==='current'">
        <!-- Select Scheme -->
          <div class="col-md-6 col-sm-12">
                <div class="form-group padding-right-10">
                  <mat-form-field>
                    <mat-label>Select Scheme</mat-label>
                   <input type="text" [formControl]="schemeControl" placeholder="Select Scheme" matInput [matAutocomplete]="schemeAutocomplete">
                   <button mat-icon-button matSuffix (click)="showAllScheme()" tabindex="-1">
                      <mat-icon>arrow_drop_down</mat-icon>
                    </button>
                   <!-- <mat-autocomplete #schemeAutocomplete="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onSchemeChange($event)"> -->
                    <mat-autocomplete
                    #schemeAutocomplete="matAutocomplete"
                    [displayWith]="displayFn"
                    autoActiveFirstOption
                    (optionSelected)="onSchemeChange($event)">
                    <mat-option *ngFor="let item of filteredSchemeList | async" [value]="item">
                      {{ item.scheme }}
                    </mat-option>
                  </mat-autocomplete>
                  </mat-form-field>
                </div>
          </div>
        <!-- Select Plan -->
            <div class="col-md-6">
                  <div class="form-group stretch">
                    <mat-form-field>
                      <mat-label>Select Plan</mat-label>
                        <!-- <mat-select
                        disableOptionCentering
                        placeholder="Select Plan"
                        [(ngModel)]="userData.plan"
                        name="schemePlan"
                        #schemePlan="ngModel"> -->
                        <mat-select
                        disableOptionCentering
                        placeholder="Select Plan"
                        [(ngModel)]="userData.plan"
                        name="schemePlan"
                        #schemePlan="ngModel"
                        (openedChange)="onPlanOpened($event)">
                        <mat-option *ngFor="let item of planList" [value]="item.plan">
                          {{item.plan}}
                        </mat-option>
                    </mat-select>
                    </mat-form-field>
                  </div>
                  </div>
    </div>

    <div class="col-lg-12 row ">
      <button type="button" (click)="getTableDataSubmit()" class="submit-button ">Submit</button>
    </div>
    <br>
  </div>

  <br><br>

  <!--FILTERED LIST-->
  <div class="col-lg-12" #tableResults tabindex="-1">
    <div class="sr-only" role="status" aria-atomic="true"> {{liveMessage}} </div>
    <table class="table " svSortBy="name" svSortOrder="asc"
      *ngIf="data && data.length>0 && activeTab==='nav'">
      <caption class="section-caption"> Net Asset Value (NAV) details by fund </caption>
      <thead>
        <tr>
          <th> Fund Name </th>
          <th class="text-center"> Date </th>
          <th class="text-center"> Current NAV </th>
          <th class="text-center"> Previous NAV </th>
          <th class="text-center"> Change </th>
          <th class="text-center"> Percentage </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of data | paginate: { itemsPerPage: pageSize, currentPage: currentPage }">
          <td>{{ item.scheme }}<br><span class="sub-data">{{ item.plan }}</span></td>
          <td class="text-center">{{ item.date | date: 'dd MMM yyyy'  }}</td>
          <td class="text-center"> &#8377; {{ item.currentNav | number :'1.4-4' }}</td>
          <td class="text-center"> &#8377; {{ item.previousNav | number : '1.4-4'}}</td>
          <td class="text-center"> &#8377; {{ item.change }}</td>
          <!-- <td class="text-center">
            <img src="assets/icons/share_down.png" *ngIf="item.percentage<0">
            <img src="assets/icons/share_up.png" *ngIf="item.percentage>=0">
            {{ item.percentage | number : '1.2-2'}}
          </td> -->
          <td class="text-center">
          <img
            src="assets/icons/share_down.png"
            *ngIf="item.percentage < 0"
            alt="Decrease in percentage"
            aria-label="Decrease in percentage">

          <img
            src="assets/icons/share_up.png"
            *ngIf="item.percentage >= 0"
            alt="Increase in percentage"
            aria-label="Increase in percentage">

          {{ item.percentage | number : '1.2-2' }}
        </td>
        </tr>
      </tbody>
      <!-- <tfoot>
        <tr>
          <td colspan="6" class="center-paginator">
            <pagination-controls (pageChange)="pageChanged($event,'current')"></pagination-controls>
          </td>
        </tr>
      </tfoot> -->
    </table>
    

<div class="center-paginator"
    *ngIf="data && data.length > pageSize && activeTab === 'nav'"
     role="navigation"
     aria-label="Pagination">
  <pagination-controls
      (pageChange)="pageChanged($event,'current')">
  </pagination-controls>
</div>

    <table class="table " svSortBy="name" svSortOrder="asc"
      *ngIf="data && data.length>0 && activeTab!=='nav'">
      <caption class="section-caption"> Latest IDCW details by fund </caption>
      <thead>
        <tr>
          <th> Fund Name </th>
          <th class="text-center"> Record Date </th>
          <th class="text-center"> Individual </th>
          <th class="text-center"> Corporate </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of data | paginate: { itemsPerPage: pageSize, currentPage: currentPageTab  }">
          <td>{{ item.scheme }}<br><span class="sub-data">{{ item.plan }}</span></td>
          <td class="text-center">{{ item.recordDate | date: 'dd MMM yyyy'  }}</td>
          <td class="text-center"> &#8377; {{ item.individual }}</td>
          <td class="text-center"> &#8377; {{ item.corporate }}</td>
        </tr>
      </tbody>
      <!-- <tfoot>
        <tr>
          <td colspan="4" class="center-paginator">
            <pagination-controls (pageChange)="pageChanged($event,'tab')"></pagination-controls>
          </td>
        </tr>
      </tfoot> -->
    </table>
   

<div class="center-paginator"
    *ngIf="data && data.length > pageSize && activeTab !== 'nav'"
     role="navigation"
     aria-label="Pagination">
  <pagination-controls
      (pageChange)="pageChanged($event,'tab')">
  </pagination-controls>
</div>
    
 
    <div *ngIf="!data || data.length<=0" class="text-center">
      <h2>No Data Available</h2>
    </div>

    

    <div class="col-lg-12 row center-block" *ngIf="data && data.length>0">
      <button type="button" (click)="downloadXls()" class="submit-button2 "> Download .xls </button>

    </div>
  </div>
  <br><br> <br>
</div>


<!--MOBILE VIEW-->
<div class="nav-dividends-main nav-dividends-main-mobile content-mobile-section" *ngIf="isMobile">
  <div class="col-12 row mobile-header-tab">
      <!-- <div class=" tab-set cursor-pointer radius-left" [ngClass]="{'active-tab':activeTab==='nav'}"
        (click)="setActive('nav')"> -->
      <div
      #mainTab
      class="tab-set cursor-pointer text-center radius-left"
      role="tab"
      [attr.aria-selected]="activeTab==='nav'"
      [ngClass]="{'active-tab':activeTab==='nav'}"
      (click)="setActive('nav')"
      (keydown)="onMainTabKeydown($event, 0)"
      [attr.tabindex]="activeTab === 'nav' ? '0' : '-1'"
      id="mobile-tab-nav"
      aria-controls="mobile-panel-nav">
            <span class="left-buttons text-center ">
              <a class="tab-btn-text">NAV</a>
            </span>
          </div>
      <!-- <div class="tab-set cursor-pointer radius-right" [ngClass]="{'active-tab':activeTab==='dividends'}"
        (click)="setActive('dividends')"> -->
      <div
      #mainTab
      class="tab-set cursor-pointer radius-right"
      role="tab"
      [attr.aria-selected]="activeTab==='dividends'"
      [ngClass]="{'active-tab':activeTab==='dividends'}"
      (click)="setActive('dividends')"
      (keydown)="onMainTabKeydown($event, 1)"
      [attr.tabindex]="activeTab === 'dividends' ? '0' : '-1'"
      id="mobile-tab-idcw"
      aria-controls="mobile-panel-idcw">
        <span class="left-buttons text-center ">
          <a class="tab-btn-text">IDCW</a>
        </span>
      </div>
  </div>
  <div class="data-section-nav">
    <div class="col-12 row nav-tabs-section">
        <select  class="select-data custom-select-mobile" [(ngModel)]="activeTabSub" (click)="setActiveSub(activeTabSub)">
          <option value="current" *ngIf="activeTab==='nav'">Current NAV</option>
          <option value="current" *ngIf="activeTab==='dividends'">Latest IDCW </option>
          <option value="historic" *ngIf="activeTab==='nav'">Historic NAV</option>
          <option value="historic" *ngIf="activeTab==='dividends'">Historic IDCW</option>
        </select>
    </div>
    <!--HISTORIC TAB-->
    
    <div class="col-lg-12 row filters" *ngIf="activeTabSub==='historic'">
        <!-- Select Scheme -->
        <div class="col-lg-3">
          <div class="form-group padding-right-10">
            <mat-form-field>
              <mat-label>Select Scheme</mat-label>
              <input type="text" [formControl]="schemeControl" placeholder="Select Scheme" matInput [matAutocomplete]="schemeAutocomplete">
              <button mat-icon-button matSuffix (click)="showAllScheme()" tabindex="-1">
                 <mat-icon>arrow_drop_down</mat-icon>
               </button>
              <!-- <mat-autocomplete #schemeAutocomplete="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onSchemeChange($event)"> -->
                <mat-autocomplete
                #schemeAutocomplete="matAutocomplete"
                [displayWith]="displayFn"
                autoActiveFirstOption
                (optionSelected)="onSchemeChange($event)">
               <mat-option *ngFor="let item of filteredSchemeList | async" [value]="item">
                 {{ item.scheme }}
               </mat-option>
             </mat-autocomplete>
             </mat-form-field>
          </div>
      </div>
        <!-- Select Plan -->
      <div class="col-lg-3">
        <div class="form-group stretch">
          <mat-form-field>
            <mat-label>Select Plan</mat-label>
              <!-- <mat-select
              disableOptionCentering
              placeholder="Select Plan"
              [(ngModel)]="userData.plan"
              name="schemePlan"
              #schemePlan="ngModel"> -->
              <mat-select
              disableOptionCentering
              placeholder="Select Plan"
              [(ngModel)]="userData.plan"
              name="schemePlan"
              #schemePlan="ngModel"
              (openedChange)="onPlanOpened($event)">
              <mat-option *ngFor="let item of planList" [value]="item.plan">
                {{item.plan}}
              </mat-option>
          </mat-select>
          </mat-form-field>
        </div>
      </div>
       <!-- Select From Date -->
      <div class="col-lg-3">
        <div class="form-group">
        <mat-form-field>
          <mat-label>From</mat-label>
          <input
              type="text"
              matInput
              [matDatepicker]="picker1"
              [(ngModel)]="userData.fromDate"
              name="fromDate"
              [max]="today"
          >
          <mat-datepicker-toggle
              matSuffix
              [for]="picker1"
              aria-label="Open calendar for: From"
          ></mat-datepicker-toggle>
          <mat-datepicker
              #picker1
              color="primary"
          ></mat-datepicker>
      </mat-form-field>
      </div>
      </div>
       <!-- Select From Date -->
      <div class="col-lg-3">
        <div class="form-group">
          <mat-form-field>
            <mat-label>To</mat-label>
              <input
                  type="text"
                  matInput
                  [matDatepicker]="picker2"
                  [(ngModel)]="userData.toDate"
                  name="toDate"
                  [max]="today"
                  [min]="userData.fromDate"
              >
              <mat-datepicker-toggle
                  matSuffix
                  [for]="picker2"
                  aria-label="Open calendar for: To"
              ></mat-datepicker-toggle>
              <mat-datepicker
                  #picker2
                  color="primary"
              ></mat-datepicker>
          </mat-form-field>
      </div>
      </div>
    </div>
    <!--NAV - CURRENT TAB -->
    <div class="row width-stretch-65 margin-auto" *ngIf="activeTabSub==='current'">
      <!-- Select Scheme -->
        <div class="col-md-6 col-sm-12">
              <div class="form-group padding-right-10">
                <mat-form-field>
                  <mat-label>Select Scheme</mat-label>
                 <input type="text" [formControl]="schemeControl" placeholder="Select Scheme" matInput [matAutocomplete]="schemeAutocomplete">
                 <button mat-icon-button matSuffix (click)="showAllScheme()" tabindex="-1">
                    <mat-icon>arrow_drop_down</mat-icon>
                  </button>
                 <!-- <mat-autocomplete #schemeAutocomplete="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onSchemeChange($event)"> -->
                  <mat-autocomplete
                  #schemeAutocomplete="matAutocomplete"
                  [displayWith]="displayFn"
                  autoActiveFirstOption
                  (optionSelected)="onSchemeChange($event)">
                  <mat-option *ngFor="let item of filteredSchemeList | async" [value]="item">
                    {{ item.scheme }}
                  </mat-option>
                </mat-autocomplete>
                </mat-form-field>
              </div>
        </div>
      <!-- Select Plan -->
          <div class="col-md-6">
                <div class="form-group stretch">
                  <mat-form-field>
                    <mat-label>Select Plan</mat-label>
                      <mat-select
                      disableOptionCentering
                      placeholder="Select Plan"
                      [(ngModel)]="userData.plan"
                      name="schemePlan"
                      #schemePlan="ngModel">
                      <mat-option *ngFor="let item of planList" [value]="item.plan">
                        {{item.plan}}
                      </mat-option>
                  </mat-select>
                  </mat-form-field>
                </div>
                </div>
     </div>
    <div class="col-lg-12 row ">
      <button type="button" (click)="getTableDataSubmit()" class="submit-button ">Submit</button>
    </div>
    <br>
  </div>
  <br><br>

  <!--Mobile - Filterd Data Value-->
  <div class="col-lg-12 mobile-table">
    <!-- <table class="table " [svData]="data" #sv="svDataTable" [svRowsOnPage]="5" svSortBy="name" svSortOrder="asc"
      *ngIf="data && data.length>0 && activeTab==='nav'"> -->
    <table class="table " svSortBy="name" svSortOrder="asc"
      *ngIf="data && data.length>0 && activeTab==='nav'">
      <caption class="section-caption"> Net Asset Value (NAV) details by fund </caption>
      <thead>
        <tr>
          <th> Fund Name </th>
          <th class="text-center"> Date </th>
          <th class="text-center"> Current NAV </th>
          <th class="text-center"> Previous NAV </th>
          <th class="text-center"> Change </th>
          <th class="text-center"> Percentage </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of data | paginate: { itemsPerPage: pageSize, currentPage: currentPageMobile  }">
          <td>{{ item.scheme }}<br><div class="sub-data">{{ item.plan }}</div></td>
          <td class="text-center">{{ item.date | date: 'dd MMM yyyy'  }}</td>
          <td class="text-center"> &#8377; {{ item.currentNav | number : '1.4-4' }}</td>
          <td class="text-center"> &#8377; {{ item.previousNav | number : '1.4-4'}}</td>
          <td class="text-center"> &#8377; {{ item.change }}</td>
          <!-- <td class="text-center">
            <img src="assets/icons/share_down.png" *ngIf="item.percentage<0">
            <img src="assets/icons/share_up.png" *ngIf="item.percentage>=0">
            {{ item.percentage | number : '1.2-2'}}
          </td> -->
          <td class="text-center">
          <img
            src="assets/icons/share_down.png"
            *ngIf="item.percentage < 0"
            alt="Decrease in percentage"
            aria-label="Decrease in percentage">

          <img
            src="assets/icons/share_up.png"
            *ngIf="item.percentage >= 0"
            alt="Increase in percentage"
            aria-label="Increase in percentage">

          {{ item.percentage | number : '1.2-2' }}
        </td>
        </tr>
      </tbody>
      <!-- <tfoot>
        <tr>
          <td colspan="6" class="center-paginator">
             <pagination-controls (pageChange)="pageChanged($event,'mobile')"></pagination-controls>
          </td>
        </tr>
      </tfoot> -->
    </table>
    

<div class="center-paginator"
     *ngIf="data && data.length > pageSize && activeTab === 'nav'"
     role="navigation"
     aria-label="Pagination">
  <pagination-controls
      (pageChange)="pageChanged($event,'mobile')">
  </pagination-controls>
</div>


    <table class="table " svSortBy="name" svSortOrder="asc"
      *ngIf="data && data.length>0 && activeTab!=='nav'">
      <caption class="section-caption"> Latest IDCW details by fund </caption>
      <thead>
        <tr>
          <th> Fund Name </th>
          <th class="text-center"> Record Date </th>
          <th class="text-center"> Individual </th>
          <th class="text-center"> Corporate </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of data | paginate: { itemsPerPage: pageSize, currentPage: currentPageNav  }">
          <td>{{ item.scheme }}<br><span class="sub-data">{{ item.plan }}</span></td>
          <td class="text-center">{{ item.recordDate | date: 'dd MMM yyyy'  }}</td>
          <td class="text-center"> &#8377; {{ item.individual }}</td>
          <td class="text-center"> &#8377; {{ item.corporate  }}</td>
        </tr>
      </tbody>
      <!-- <tfoot>
        <tr>
          <td colspan="4" class="center-paginator">
            <pagination-controls (pageChange)="pageChanged($event,'nav')"></pagination-controls>
          </td>
        </tr>
      </tfoot> -->
    </table>
    

<div class="center-paginator"
    *ngIf="data && data.length > pageSize && activeTab !== 'nav'"
     role="navigation"
     aria-label="Pagination">
  <pagination-controls
      (pageChange)="pageChanged($event,'nav')">
  </pagination-controls>
</div>
    <div *ngIf="!data || data.length<=0" class="text-center">
      <h2>No Data Available</h2>
    </div>
    <div class="col-lg-12 row center-block" *ngIf="data && data.length>0">
      <button type="button" (click)="downloadXls()" class="submit-button2 "> Download .xls </button>

    </div>
  </div>
  <br><br> <br>
</div>
